/**
 * Merge a query string with the params every route must carry.
 *
 * Appends rather than building an object: a query can hold the same key more
 * than once, which the Contacts page relies on for an ad-hoc filter group
 * (`0={"a":1}&0={"b":2}`). Rebuilding through `Object.fromEntries` kept only the
 * last value of each key, so writing any other param dropped filter conditions
 * from the address. A required param still wins over one of the same name.
 */
export const mergeQueryParams = (
  queryString: string,
  requiredQueryParams: URLSearchParams
): URLSearchParams => {
  const merged = new URLSearchParams()

  for (const [key, value] of new URLSearchParams(queryString).entries()) {
    if (requiredQueryParams.has(key)) continue

    merged.append(key, value)
  }

  for (const [key, value] of requiredQueryParams.entries()) {
    merged.append(key, value)
  }

  return merged
}
